export const HERO_IMAGE = "/img/owl-typing.webp";
export const OWL_SCRATCH = "/img/owl-scratch.webp";
export const MASCOT_IMAGE = "/img/owl-beanbag.webp";  // the typing-practice owl — owl-teacher is retired
export const OWL_ORANGE = "/img/owl-logo.webp";
export const OWL_LAPTOP = "/img/owl-laptop.webp";
export const STUDENT_HERO = "/img/student-hero.webp";
export const BUMA_LOGO = "/img/buma-logo-sm.webp";
export const BUMA_LOGO_AR = "/img/buma-logo-ar.webp";
export const AHDAF_LOGO = "/img/ahdaf-logo.webp";
export const OWL_FLYING = "/img/owl-flying.webp";
export const OWL_TEEN = "/img/owl-teen.webp";  // learners 12+ (hoodie + microphone) on the start page; younger kids keep MASCOT_IMAGE
